import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { AccordionSummary, AccordionSummaryProps } from '@mui/material';

const PlusAccordionSummary = ({ isExpanded, ...props }: AccordionSummaryProps & { isExpanded?: boolean | null }) => {
    return (
        <AccordionSummary
            expandIcon={isExpanded !== null ? isExpanded ? <RemoveIcon /> : <AddIcon /> : null}
            {...props}
        />
    );
};

export { PlusAccordionSummary };
